import './theme/algaeTheme'; // need to import the theme to apply types augmentation for palette and typography
export * from './components/';
export { default as Layout } from './pageLayout';
export { theme } from './theme/landingPage';
export { colors } from './theme/default/color';
export * from './theme/utils/useBreakpoints';
export * from './utils/getCmsOptimizedUrl';
export * from './utils/formatDate.js';
export * from './utils/handelScrollToRef';
export * from './utils/muiThemeWrapper';
